import React from 'react';
import { Link } from 'react-router';
import Slider from 'react-slick';
import charleneImage from './assets/charlene.jpg';
import dennisImage from './assets/dennis.jpg';
import katieImage from './assets/katie.jpg';
import getaroundImage from './assets/getaround.png';
import satchelImage from './assets/satchel.png';
import fullscreenImage from './assets/fullscreen.png';
import styles from './styles.scss';

function Testimonials () {
  return (
    <div>
      <div className="row">
        <div className="col-md-8 col-md-offset-2">
          <div className="text-center">
            <h1 className={`${styles.header} bold-italics blue text-center mb50`}>
              Who will I be working with?
            </h1>
          </div>
        </div>
      </div>
      <Slider dots autoplay infinite autoplaySpeed="7000">
        <div>
          <div className={styles.testimonial}>
            <div className={styles.clientImage}>
              <img src={charleneImage} alt="charlene" />
              <div className={`${styles.clientInfo} hidden-xs`}>
                <p className="bold">Charlene Foote</p>
                <p>Getaround</p>
              </div>
            </div>
            <div className={styles.description}>
              <p>
                Meet Charlene! She's a Portland-based product designer with 10
                years of experience and proficient in wireframing,
                prototyping, and designing for development.
              </p>
              <img src={getaroundImage} alt="Getaround" />
            </div>
          </div>
        </div>
        <div>
          <div className={styles.testimonial}>
            <div className={styles.clientImage}>
              <img src={dennisImage} alt="charlene" />
              <div className={`${styles.clientInfo} hidden-xs`}>
                <p className="bold">Dennis Cortés</p>
                <p>Satchel Health</p>
              </div>
            </div>
            <div className={styles.description}>
              <p>
                Meet Dennis! He's a St. Louis-based branding
                designer, founder, and self-starter. Along
                with leading design at Satchel Health, he's
                started Taste Notes, Quary, and Sogol.
              </p>
              <img src={satchelImage} alt="satchel" />
            </div>
          </div>
        </div>
        <div>
          <div className={styles.testimonial}>
            <div className={styles.clientImage}>
              <img src={katieImage} alt="charlene" />
              <div className={`${styles.clientInfo} hidden-xs`}>
                <p className="bold">Katie Guernsey</p>
                <p>Fullscreen</p>
              </div>
            </div>
            <div className={styles.description}>
              <p>
                Meet Katie! She's a Senior Product Manager
                based in LA with 10 years of experience in
                product management and business development.
              </p>
              <img src={fullscreenImage} alt="Fullscreen" />
            </div>
          </div>
        </div>
      </Slider>
      <div className={styles.seeWork}>
        <Link to='/talent' target="_blank" className="btn btn-dc-blue">
          SEE PAST WORK
        </Link>
      </div>
    </div>
  );
}

export default Testimonials;



// WEBPACK FOOTER //
// ./src/components/StartupDesigners/index.js